import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { LogsProvider } from '../../contexts/LogsContext';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const LogsScreen = Loader(lazy(() => import('../../content/pages/Logs/LogsScreen')));

type CustomRouteObject = RouteObject & {
  children?: CustomRouteObject[];
};

export const createLogsRoutes = (): CustomRouteObject => ({
  path: 'logs',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['viewLogs']} should404>
          <LogsProvider>
            <LogsScreen />
          </LogsProvider>
        </PermissionsGuard>
      )
    }
  ]
});
